export default __webpack_public_path__ + "static/ampersand-color-change-b55d4ff1bee51fe7febef95a7e924802.mp4";